/**
 * INFO:NOTE: Use the following semver tags format:
 * X.Y.Z-alpha   for developer branches (works in progress)
 * X.Y.Z-beta.W  for test releases (feature branch)
 * X.Y.Z-rc.W    for pre-prod releases ('dev' branch)
 * X.Y.Z         for prod releases ('master' branch)
*/

export const APP_VERSION = '1.34.13';
export const BUILD_NAME = 'CalendarFix::all_day';

/** Use another token to emulate a session. */
export const EMULATED_SESSION = {
  EMAIL: '',
  AUTH_TOKEN: '',
  ACCESS_TOKEN: '',
};

export const IS_LOCALHOST = window.location.hostname === 'localhost';
export const IS_STAGING = window.location.hostname.includes('staging') || window.location.hostname.includes('qa-');
export const IS_PULL_REQUEST = window.location.hostname.includes('pr-');
export const IS_PROD = !(IS_LOCALHOST || IS_STAGING || IS_PULL_REQUEST);
export const ENV = IS_PROD ? 'PRODUCTION' : 'STAGE';
export const LOCALES_PATH = `${IS_LOCALHOST ? '/../app/' : '/app/'}locales/{{lng}}/{{ns}}.json?v=${APP_VERSION}`;
export const FILES_API_URL = process.env.REACT_APP_AWS_SIGNATURE_URL;
export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT || 'PRODUCTION';
export const IS_PRODUCTION = ENVIRONMENT === 'PRODUCTION';


export const CORE_API_URL = process.env.REACT_APP_CORE_API_URL || '';
export const CORE_WEBHOOKS_URL = process.env.REACT_APP_CORE_WEBHOOKS_URL || '';
export const CLIENT_API_URL = process.env.REACT_APP_CLIENT_API_URL || '';
export const MESSAGES_API_URL = process.env.REACT_APP_MESSAGES_API_URL || '';
export const MESSAGES_API_TOKEN = process.env.REACT_APP_MESSAGES_API_TOKEN || '';
export const MIXPANEL_API_KEY = process.env.REACT_APP_MIXPANEL_API_KEY || '';
export const STRIPE_API_KEY = process.env.REACT_APP_STRIPE_API_KEY || '';
export const FB_PIXEL_ID = process.env.REACT_APP_FB_PIXEL_ID || '';
export const GTM_ID = process.env.REACT_APP_GTM_ID || '';
export const GA_ID = process.env.REACT_APP_GA_ID || '';
export const ROLLBAR_TOKEN = process.env.REACT_APP_ROLLBAR_TOKEN || '';
export const S3_BUCKET_VIDEOS = process.env.REACT_APP_S3_BUCKET_VIDEOS || '';
export const S3_BUCKET_FILES = process.env.REACT_APP_S3_BUCKET_FILES || '';
export const AWS_REGION = process.env.REACT_APP_AWS_REGION || '';
export const S3_URL_VIDEOS = process.env.REACT_APP_S3_URL_VIDEOS || '';
export const S3_URL_FILES = process.env.REACT_APP_S3_URL_FILES || '';
export const AWS_KEY = process.env.REACT_APP_AWS_KEY || '';

export const OAUTH_CLIENT_ID = {
  LOCAL: '766607178884-3desdgibo8ltfvo30ihsf560ipqqved7.apps.googleusercontent.com',
  STAGE: '766607178884-8sb6576o437ki6v0n64m04nd5ant1d4k.apps.googleusercontent.com',
  PRODUCTION: '766607178884-6l1hq07thlgrjrcdg27fq18f1bemj6tu.apps.googleusercontent.com',
}[IS_LOCALHOST ? 'LOCAL' : ENVIRONMENT];

export const REACT_APP_SENTRY_DNS = process.env.REACT_APP_SENTRY_DNS || '';
// eslint-disable-next-line max-len
export const REACT_APP_SENTRY_TRACESSAMPLERATE = process.env.REACT_APP_SENTRY_TRACESSAMPLERATE || 1.0;
